<template>
  <v-container fluid grid-list-xl>
    <v-flex xs12 md12>
      <cpn-select-competence
        :power_plants="power_plants"
      ></cpn-select-competence>
      <cpnInvoiceItensCompetence
        v-if="!this.$apollo.loading"
      ></cpnInvoiceItensCompetence>
    </v-flex>
  </v-container>
</template>
<script>
import SelectCompetence from "../../components/faturar/SelectCompetence";
import InvoiceItensCompetence from "../../components/faturaDetails/InvoiceItensCompetence";
import { EventBus } from "../../utils/event-bus";
import { GET_POWERPLANTCOMBO } from "../../graphql/powerplants";

export default {
  data: function () {
    return {
      invoices: [],
      power_plants: [],
      invoice: {},
      totals: {},
      loading: false,
      competence: "",
      power_plant: "ufvpedralva1",
    };
  },
  components: {
    cpnSelectCompetence: SelectCompetence,
    cpnInvoiceItensCompetence: InvoiceItensCompetence,
  },
  created() {
    EventBus.$on("competenceSelected", (competence) => {
      this.competence = competence;
    });
  },
  apollo: {
    powerplants: {
      query: GET_POWERPLANTCOMBO,
      // Optional result hook
      result({ data, loading }) {
        this.power_plants = data.powerplants;
        this.loading = loading;
      },
      // Error handling
      error(error) {
        console.error("We've got an error!", error);
      },
    },
  },
};
</script>
<style></style>
